import React from "react";
import Box from "@mui/material/Box";
import { Stack, TextFieldProps } from "@mui/material";
import { WcCheckBox } from "../WcCheckBox/WcCheckBox";
import WcNumber from "../WcNumber/WcNumber";
import { Typography } from "@mui/material";

export type WcCheckBoxTextFieldProps = TextFieldProps & {
  checkBoxLabelText: string;
  controlDisabled?: boolean;
  checkBoxValue?: boolean;
  checkboxNumber?: any;
  width?: number;

  onValueChanged: (valueParam: any, checkBoxInput: boolean) => void;
};

export interface WcCheckBoxTextFieldState {
  checkBoxValue: boolean;
  checkboxNumber: any;
}

export const WcCheckBoxTextField = (props: WcCheckBoxTextFieldProps) => {
  const {
    controlDisabled,
    checkBoxLabelText,
    checkBoxValue = false,
    checkboxNumber = 0,
    width,
    onValueChanged,
    ...others
  } = props;

  const [checkStateValue, setCheckStateValue] =
    React.useState<WcCheckBoxTextFieldState>({
      //@ts-ignore
      checkBoxValue: checkBoxValue,
      //@ts-ignore
      checkboxNumber: checkboxNumber,
    });

  React.useEffect(() => {
    onValueChanged(
      checkStateValue.checkboxNumber,
      checkStateValue.checkBoxValue
    );
  }, [checkStateValue]);

  const handleSliderChange = (event: any) => {
    setCheckStateValue({
      ...checkStateValue,
      checkBoxValue: event.target.checked,
    });
  };

  const handleInputChange = (val: number) => {
    setCheckStateValue({
      ...checkStateValue,
      checkboxNumber: val,
    });
  };

  return (
    <Box padding={1} id="WcSlider" sx={{ width: width }}>
      <Stack
        width={"100%"}
        spacing={5}
        justifyContent="space-between"
        direction="row"
      >
        <Typography id="input-slider" gutterBottom>
          {checkBoxLabelText}
        </Typography>

        <Stack spacing={5} padding={0} direction={"row"}>
          <WcCheckBox
            onChange={(event) => handleSliderChange(event)}
            controlDisabled={controlDisabled}
            checked={checkStateValue.checkBoxValue}
          />

          <Stack width={100} padding={0}>
            <WcNumber
              value={checkStateValue.checkboxNumber}
              placeholder="0"
              hiddenLabel
              onValue={handleInputChange}
              disabled={checkStateValue.checkBoxValue === false}
              variant="filled"
              suffix="%"
              isString
            />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
export default WcCheckBoxTextField;
